import { Router } from '@reach/router';
import React from 'react';
import Detail from './pages/Detail';
import Index from './pages/Index';
import Method from './pages/Method';
import { useStateValue } from './state';
import './App.scss';

export default () => {
  const [{
    modal: {
      show,
    },
  }] = useStateValue();

  return (
    <Router
      className="router"
      style={{
        overflow: show ? 'hidden' : 'unset',
      }}
    >
      <Index path="/" />
      <Method path=":method" />
      <Detail path=":method/:detail" />
    </Router>
  );
};
